/**
 * A phone keeps the app open for days, and the browser only looks for a new
 * service worker on navigation. Ask for one on a timer instead (skipped
 * without signal, the check would only fail).
 */
export function scheduleUpdateCheck(registration: ServiceWorkerRegistration, intervalMs: number): () => void {
  const timer = setInterval(() => {
    if (registration.installing !== null || !navigator.onLine) {
      return;
    }

    void registration.update().catch(() => undefined);
  }, intervalMs);

  return () => clearInterval(timer);
}
